import React from 'react'
import background from 'assets/img/auth/background.jpg';

interface SideImageProps {
    className: string
}

export const SideImage = ({ className }: SideImageProps) => {
    return (
        <div className={className}>
            <div className="bg-auto bg-center bg-no-repeat bg-cover w-full h-screen" style={{ backgroundImage: `url(${background})` }} ></div>
        </div>
    )
}
